import { Modal } from '@iwoca/orion';

import styles from './FetchOffersModal.module.css';
import CheckingEligibility from '../AutomatedLendingDecision/CheckingEligibility/CheckingEligibility';

const FetchOffersModal = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            data-testid="fetch-offers-modal"
            className={styles.modalContainer}>
            <CheckingEligibility />
        </Modal>
    );
};

export default FetchOffersModal;
